import SliderWrapper from '../utils/SliderWrapper'
import { connect } from 'react-redux';
import { getCarpenterSub } from '../../actions'
import { useEffect } from 'react'


const CarpenterSlider = (props) => {
    // const [loading, setLoading] = useState(true)
    const { id, slug } = props.carpenter
    const { getCarpenterSub, mobileNav } = props
    useEffect(() => {
        if (id && slug){
            getCarpenterSub(id, slug)
        }
    }, [id, slug, getCarpenterSub])
    // return <SliderWrapper sliderItemData={props.cP} heading="Carpentry Services" height={mobileNav ? '160px' : '180px'} mobileNav={mobileNav} to={`/services/${slug}`} extraInnerWidth={40} loading={loading} setLoading={setLoading}/>
    return <div className="slider-main__container"><SliderWrapper sliderItemData={props.cP} heading="Carpentry Services" height={mobileNav ? '148px' : '180px'} mobileNav={mobileNav} to={`/services/${slug}`} extraInnerWidth={40}/></div>
}
const mapStateToProps = (state) => {
    let carpenter = {};
    if (!state.EmployeeCategory.loading){
        state.EmployeeCategory.data.forEach(x => {
            if (x.slug === 'carpenter'){
                carpenter.id = x.id
                carpenter.slug = x.slug
            }
        });
    }
    const cP = state.cP.data.filter(x => x.id !== 28) 
    return {
        mobileNav: state.mobileNav,
        carpenter: carpenter,
        cP: cP,
    }
}
export default connect(mapStateToProps, { getCarpenterSub })(CarpenterSlider)